import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
} from '@angular/core';

import {
  AlertsComponent,
  AlertsService,
  NotImplementedYetService,
  SocialIconComponent,
  SocialIconType,
} from '@web/shared/ui';
import { SignInFormComponent } from '../../components/sign-in-form/sign-in-form.component';
import { SignInForm } from '../../models/sign-in-form';
import { AuthService } from '../../services/auth.service';
import { HttpErrorService } from '@web/common';
import { FormTitleWithSubtitleComponent } from '../../ui/form-title-with-subtitle/form-title-with-subtitle.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-sign-in',
  imports: [
    FormTitleWithSubtitleComponent,
    SignInFormComponent,
    SocialIconComponent,
    AlertsComponent,
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class SignInComponent {
  private readonly notImplementedYet = inject(NotImplementedYetService);
  private readonly auth = inject(AuthService);
  private readonly alerts = inject(AlertsService);
  private readonly httpError = inject(HttpErrorService);

  public readonly shouldShowSocials = input(false);
  public readonly signInSuccessEvent = output();

  protected readonly SocialIconType = SocialIconType;

  private readonly destroyRef = inject(DestroyRef);

  public handleSubmitClickEvent(data: SignInForm): void {
    this.auth
      .signInByCredentials(data.usernameOrEmail, data.password, data.rememberMe)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.signInSuccessEvent.emit();
        },
        error: (response) => {
          this.showFailureAlertByResponse(response);
        },
      });
  }

  public handleSignInByFacebookClick(): void {
    this.notImplementedYet.showToast();
  }

  public handleSignInByGoogleClick(): void {
    this.notImplementedYet.showToast();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
